import { Box, Link, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles({
  bodyText: {
    "&.MuiTypography-root": {
      color: "#AAAAAA",
      fontFamily: "Rajdhani, sans-serif",
      fontWeight: "500",
      fontSize: "2.5rem",
      lineHeight: "3.5rem",
    },
  },
  bodyText2: {
    "&.MuiTypography-root": {
      fontFamily: "Rajdhani, sans-serif",
      fontWeight: "500",
      fontSize: "2.3rem",
      lineHeight: "4.5rem",
    },
  },
  link: {
    "&.MuiTypography-root": {
      color: "#08FDD8",
    },
    "&:hover": {
      color: "#FF4D5A",
    },
  },
});

function SkillBodyText(props) {
  const classes = useStyles();
  const { skillText } = props;
  return (
    <Box
      component="div"
      sx={{
        margin: "12rem 0rem",
        padding: "5px",
      }}
    >
      <Typography variant="body1" component="div" className={classes.bodyText}>
        {skillText}
      </Typography>
      <Typography
        variant="body2"
        component="div"
        className={classes.bodyText2}
        mt={5}
      >
        Visit my{" "}
        <Link
          className={classes.link}
          href="https://www.linkedin.com/in/touhid-alam-09/"
          underline="hover"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </Link>{" "}
        profile for more details or just{" "}
        <Link
          className={classes.link}
          href="#contact-container"
          underline="none"
          rel="noopener noreferrer"
        >
          contact
        </Link>{" "}
        me.
      </Typography>
    </Box>
  );
}

export default SkillBodyText;
